import { RESTClient, RESTClientMock } from './client';
import { API_URL } from './apiDictionary';
import { USE_API_MOCKS } from '../env';
import { fetchClinicalTrialContextMock } from '@api/mocks/clinicalTrialContext';
import { ContextData } from '@dynamika-shared/types/clinicalTrialContext';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchClinicalTrialContext = async (clinicalTrialId: string) => {
  if (USE_API_MOCKS) {
    fetchClinicalTrialContextMock();
  }

  try {
    const response = await api.get<ContextData>(
      API_URL.clinicalTrialContext,
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching context', error);
    throw error;
  }
};
